var exports = {
  "GA": "x804f0401--cfcdb4--answers",
  "dK": "x804f0401--cfcdb4--message-bubble",
  "ne": "x804f0401--cfcdb4--controls",
  "wI": "x804f0401--cfcdb4--answers-visibility-button",
};

module.exports = exports;
